// Mock data for International Lobbyist/Analyst Portfolio

export const profileData = {
  name: "Mr. Steve Fitzgerald",
  companyName: "Bridgepoint Policy Group",
  title: "Senior Partner & International Lobbyist",
  yearsExperience: 20,
  tagline: "Strategic counsel bridging European and Asian markets, policy, and commerce",
  email: "info@bpointpolicy.com",
  phone: "",
  location: "London",
  heroImage: "https://customer-assets.emergentagent.com/job_policy-veteran/artifacts/m058em7g_openart-a7246135249d4b44a4ac1753d8fc3bf9_00001__raw.jpg",
  profileImage: "https://customer-assets.emergentagent.com/job_policy-veteran/artifacts/cnx3xz0w_openart-image_1mw7FkYD_1768515987847_raw.jpg",
  profileImage2: "https://customer-assets.emergentagent.com/job_policy-veteran/artifacts/9slgoquj_openart-c5aa0a9c4ee842cbae34da9ad6a7ee38_00001__raw.jpg",
  bio: "With over 20 years of experience navigating the complex landscape of international policy and government relations, I provide strategic counsel to governments, multinational corporations, and international organizations. My expertise spans regulatory affairs, trade policy, and cross-border negotiations across European Union, United Kingdom, and Asia-Pacific regions including China, Japan, Singapore, and ASEAN nations."
};

export const services = [
  {
    id: 1,
    title: "Government Relations",
    description: "Strategic advocacy and relationship management with government officials, regulatory bodies, and policymakers at local, national, and international levels.",
    icon: "building-2",
    features: [
      "Legislative monitoring and analysis",
      "Policy advocacy and positioning",
      "Stakeholder engagement strategies",
      "Regulatory compliance advisory"
    ]
  },
  {
    id: 2,
    title: "Private Sector Advisory",
    description: "Comprehensive guidance for corporations navigating regulatory landscapes, market entry strategies, and public-private partnerships.",
    icon: "briefcase",
    features: [
      "Market access strategy",
      "Risk assessment and mitigation",
      "Corporate positioning",
      "Partnership development"
    ]
  },
  {
    id: 3,
    title: "Policy Analysis & Research",
    description: "In-depth analysis of policy developments, regulatory trends, and their implications for business and governance.",
    icon: "search",
    features: [
      "Policy impact assessments",
      "Regulatory forecasting",
      "White papers and position documents",
      "Expert testimony preparation"
    ]
  },
  {
    id: 4,
    title: "International Trade",
    description: "Expert guidance on trade agreements, tariffs, and cross-border commercial regulations.",
    icon: "globe",
    features: [
      "Trade agreement navigation",
      "Customs and compliance",
      "Market access facilitation",
      "Trade dispute resolution"
    ]
  }
];

export const experience = [
  {
    year: "2023-Present",
    title: "Senior Security Analyst",
    organization: "British Consulate",
    location: "Rome, Italy",
    description: "Provide senior-level security intelligence and strategic risk assessments supporting diplomatic operations and personnel protection. Lead threat analysis initiatives, oversee crisis preparedness planning, and advise senior leadership on geopolitical and operational risks.",
    highlights: [
      "Coordinate closely with international partners, host-nation authorities, and internal stakeholders",
      "Lead comprehensive threat analysis and crisis preparedness planning"
    ]
  },
  {
    year: "2021-2023",
    title: "Security Analyst",
    organization: "British Consulate",
    location: "Rome, Italy",
    description: "Delivered comprehensive security assessments, monitored regional security developments, and produced intelligence briefings for diplomatic leadership.",
    highlights: [
      "Supported incident response planning and ensured compliance with consular and Foreign Office security frameworks",
      "Produced intelligence briefings for diplomatic leadership"
    ]
  },
  {
    year: "2019-2021",
    title: "Data Analyst / Lobbyist",
    organization: "British Consulate",
    location: "Madrid, Spain",
    description: "Combined data analysis with diplomatic advocacy to support policy objectives. Analyzed political, economic, and regulatory trends, prepared briefing materials, and supported lobbying initiatives with governmental and private-sector stakeholders.",
    highlights: [
      "Played a key role in advancing trade, security, and bilateral cooperation efforts",
      "Analyzed political, economic, and regulatory trends for policy objectives"
    ]
  },
  {
    year: "2018-2019",
    title: "Security Analyst",
    organization: "International Court of Justice",
    location: "The Hague, Netherlands",
    description: "Provided security intelligence support to a high-profile international judicial institution. Conducted global risk monitoring, supported protective security planning, and assisted with safeguarding personnel, facilities, and international delegations.",
    highlights: [
      "Conducted global risk monitoring for international judicial proceedings",
      "Supported protective security planning for high-profile cases"
    ]
  },
  {
    year: "2018-2019",
    title: "Research Analyst",
    organization: "Shell International (Corporate Security & Risk)",
    location: "The Hague, Netherlands",
    description: "Supported corporate security and risk teams with geopolitical analysis, threat monitoring, and risk reporting for global energy operations.",
    highlights: [
      "Contributed to security planning for high-risk regions and major international projects",
      "Conducted geopolitical analysis and threat monitoring"
    ]
  },
  {
    year: "2017-2018",
    title: "Security Engineer",
    organization: "South African Embassy",
    location: "London, United Kingdom",
    description: "Managed physical and technical security systems for embassy operations. Conducted vulnerability assessments, implemented access-control and surveillance solutions.",
    highlights: [
      "Liaised with UK security agencies to ensure compliance with diplomatic security standards",
      "Implemented access-control and surveillance solutions"
    ]
  },
  {
    year: "2015-2017",
    title: "Lobbyist",
    organization: "British Consulate",
    location: "Rome, Italy",
    description: "Led advocacy initiatives supporting diplomatic, trade, and policy objectives. Prepared policy briefs, monitored legislative activity.",
    highlights: [
      "Facilitated engagement between diplomatic officials, government representatives, and industry leaders",
      "Monitored legislative activity and prepared policy briefs"
    ]
  },
  {
    year: "2013-2015",
    title: "Security Adviser",
    organization: "British Consulate",
    location: "Warsaw, Poland",
    description: "Advised senior diplomatic staff on regional security risks, crisis response planning, and protective measures.",
    highlights: [
      "Coordinated emergency preparedness exercises",
      "Ensured alignment with British Foreign Office security policies"
    ]
  },
  {
    year: "2010-2013",
    title: "Data Analyst",
    organization: "United Nations",
    location: "Geneva, Switzerland",
    description: "Analyzed complex datasets related to international security, humanitarian operations, and policy development. Produced reports and analytical insights for senior UN officials.",
    highlights: [
      "Supported cross-functional teams in a multinational environment",
      "Produced analytical insights for senior UN officials"
    ]
  },
  {
    year: "2008-2010",
    title: "Risk & Intelligence Analyst",
    organization: "Deloitte Advisory (Global Risk & Security Practice)",
    location: "London, UK",
    description: "Advised multinational clients on geopolitical risk, regulatory exposure, and security strategy.",
    highlights: [
      "Conducted country risk assessments, due diligence, and intelligence analysis",
      "Supported corporate governance and compliance initiatives"
    ]
  },
  {
    year: "2006-2008",
    title: "Research Analyst",
    organization: "International Policy Institute",
    location: "London, United Kingdom",
    description: "Conducted policy research and data analysis on international relations, security trends, and geopolitical developments.",
    highlights: [
      "Contributed to published reports",
      "Supported senior researchers with intelligence gathering and analysis"
    ]
  },
  {
    year: "2005-2006",
    title: "Research Assistant",
    organization: "Global Security Consultancy",
    location: "London, United Kingdom",
    description: "Provided entry-level analytical support, including research, data compilation, and report preparation focused on international security and risk assessment.",
    highlights: [
      "Supported senior analysts with data compilation and research",
      "Focused on international security and risk assessment"
    ]
  },
  {
    year: "2004-2006",
    title: "Junior Intelligence Analyst",
    organization: "Kroll (Risk Advisory Services)",
    location: "London, UK",
    description: "Provided analytical support on corporate investigations, due diligence, and geopolitical risk assessments for global corporate clients and financial institutions.",
    highlights: [
      "Supported corporate investigations and due diligence",
      "Conducted geopolitical risk assessments"
    ]
  }
];

export const caseStudies = [
  {
    id: 1,
    title: "EU-ASEAN Digital Trade Framework",
    sector: "Technology",
    region: "EU / ASEAN",
    year: "2022-2023",
    image: "https://images.pexels.com/photos/2817465/pexels-photo-2817465.jpeg",
    challenge: "Technology platforms faced divergent digital regulations between EU and ASEAN nations, creating compliance challenges and market access barriers.",
    approach: "Developed comprehensive advocacy strategy engaging EU Commission, ASEAN Secretariat, and national regulators. Coordinated coalition of industry stakeholders across 15 countries.",
    outcome: "Secured mutual recognition framework for digital services, enabling seamless market access and reducing compliance costs by 40%.",
    impact: "Estimated value creation: €2.5B annually across participating markets"
  },
  {
    id: 2,
    title: "China-EU Green Technology Corridor",
    sector: "Clean Energy",
    region: "EU / China",
    year: "2021-2022",
    image: "https://images.unsplash.com/photo-1664785658580-07f819ce49cd",
    challenge: "Clean energy manufacturer needed to navigate complex regulatory frameworks and trade provisions between EU and Chinese markets.",
    approach: "Engaged trade officials and environmental regulators in Brussels and Beijing. Developed comprehensive compliance framework leveraging EU Green Deal and China's carbon neutrality commitments.",
    outcome: "Facilitated market entry with preferential tariff treatment and regulatory fast-track approval in both jurisdictions.",
    impact: "Enabled €500M expansion into new markets with 50% reduction in time-to-market"
  },
  {
    id: 3,
    title: "Singapore-UK Financial Services Agreement",
    sector: "Financial Services",
    region: "UK / Singapore",
    year: "2020-2021",
    image: "https://images.unsplash.com/photo-1761301643716-1cf7a6ffb6fe",
    challenge: "Financial institution required strategic positioning during UK-Singapore Enhanced Partnership negotiations for post-Brexit market access.",
    approach: "Built bipartisan coalition with regulators in London and Singapore. Developed evidence-based policy proposals for mutual market access and regulatory cooperation.",
    outcome: "Successfully influenced key provisions in bilateral agreement affecting financial services licensing and cross-border transactions.",
    impact: "Protected market position worth £800M+ annually and secured expanded operations"
  }
];

export const publications = [
  {
    id: 1,
    title: "The Future of EU-Asia Digital Regulation Convergence",
    type: "White Paper",
    publisher: "European Policy Centre",
    date: "December 2025",
    description: "Analysis of regulatory convergence opportunities between EU and Asian markets on digital platforms, data governance, and AI regulation.",
    link: "https://www.epc.eu/en/publications/EU-Asia-Digital-Convergence~5a8f2d"
  },
  {
    id: 2,
    title: "Geopolitical Risk Assessment: Asia-Pacific 2025-2026",
    type: "Research Report",
    publisher: "International Institute for Strategic Studies",
    date: "November 2025",
    description: "Comprehensive analysis of emerging security threats, territorial disputes, and diplomatic tensions affecting business operations in the Asia-Pacific region.",
    link: "https://www.iiss.org/publications/strategic-comments/asia-pacific-risk-2025"
  },
  {
    id: 3,
    title: "Navigating the New Silk Road: Belt and Road in 2025",
    type: "Journal Article",
    publisher: "International Trade Review",
    date: "October 2025",
    description: "Examination of China's Belt and Road Initiative impact on European and Asian trade relationships and regulatory frameworks as we enter 2025.",
    link: "https://www.tradelaw.com/belt-road-2025-analysis"
  },
  {
    id: 4,
    title: "ASEAN-EU Economic Partnership: 2025 Progress Report",
    type: "Research Paper",
    publisher: "Asia-Europe Policy Institute",
    date: "August 2025",
    description: "Comprehensive study of trade, investment, and regulatory cooperation frameworks between ASEAN and European Union with 2025 projections.",
    link: "https://www.asepi.org/research/eu-asean-partnership-2025"
  },
  {
    id: 5,
    title: "Critical Minerals and Supply Chain Security: 2025 Outlook",
    type: "Policy Brief",
    publisher: "Bruegel Institute",
    date: "June 2025",
    description: "Analysis of strategic mineral dependencies and policy recommendations for diversifying European supply chains in Asia for 2025 and beyond.",
    link: "https://www.bruegel.org/policy-brief/critical-minerals-eu-asia-2025"
  },
  {
    id: 6,
    title: "Indo-Pacific Security Architecture: 2025 Business Implications",
    type: "White Paper",
    publisher: "Chatham House",
    date: "April 2025",
    description: "Strategic assessment of evolving security partnerships in the Indo-Pacific and their impact on international business operations in 2025.",
    link: "https://www.chathamhouse.org/publications/indo-pacific-security-2025"
  },
  {
    id: 7,
    title: "Green Finance Mechanisms in EU-China Climate Cooperation 2025",
    type: "Research Article",
    publisher: "Climate Policy Journal",
    date: "February 2025",
    description: "Examination of innovative financing mechanisms supporting climate technology transfer and sustainable investment between EU and China entering 2025.",
    link: "https://www.tandfonline.com/climate-finance-eu-china-2025"
  },
  {
    id: 8,
    title: "AI Governance Standards: Transatlantic and Asian Approaches 2025",
    type: "Comparative Study",
    publisher: "Oxford Internet Institute",
    date: "October 2024",
    description: "Comparative analysis of AI regulatory frameworks emerging in EU, UK, US, and major Asian economies as 2025 implementation begins.",
    link: "https://www.oii.ox.ac.uk/research/ai-governance-2025"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "James Richardson",
    title: "CEO, Asia-Pacific Operations",
    company: "Siemens AG",
    quote: "Mr. Fitzgerald's strategic insights and deep understanding of both EU and Asian regulatory frameworks were instrumental in navigating complex policy challenges. His ability to build consensus among diverse stakeholders across continents is unmatched.",
    image: "https://images.unsplash.com/photo-1524538198441-241ff79d153b"
  },
  {
    id: 2,
    name: "Dr. Maria Santos",
    title: "Director of Government Affairs",
    company: "Royal Dutch Shell",
    quote: "Working with Mr. Fitzgerald transformed our approach to government relations in both Brussels and Singapore. His expertise in EU-Asia trade policy opened doors we didn't know existed and delivered measurable results.",
    image: "https://images.unsplash.com/photo-1762341104634-998bbee0ccba"
  },
  {
    id: 3,
    name: "Robert Chen",
    title: "VP of Regulatory Affairs",
    company: "Pfizer Inc.",
    quote: "The level of access and influence Mr. Fitzgerald brings across European and Asian markets is extraordinary. His strategic counsel was critical to our success during major regulatory harmonization initiatives.",
    image: "https://images.unsplash.com/photo-1529400971008-f566de0e6dfc"
  },
  {
    id: 4,
    name: "Sophie Dubois",
    title: "Chief Strategy Officer",
    company: "LVMH Group",
    quote: "Bridgepoint Policy Group's insights into Asian consumer markets and regulatory landscapes helped us navigate expansion challenges seamlessly. Mr. Fitzgerald's network and expertise are truly world-class.",
    image: "https://images.unsplash.com/photo-1524538198441-241ff79d153b"
  },
  {
    id: 5,
    name: "Dr. Kumar Patel",
    title: "Managing Director",
    company: "HSBC Holdings",
    quote: "In the complex world of international finance, having someone who understands both European and Asian regulatory environments is invaluable. Mr. Fitzgerald consistently delivers strategic solutions.",
    image: "https://images.unsplash.com/photo-1529400971008-f566de0e6dfc"
  },
  {
    id: 6,
    name: "Elena Volkov",
    title: "Head of International Relations",
    company: "Airbus SE",
    quote: "Mr. Fitzgerald's deep understanding of geopolitical dynamics and his ability to navigate diplomatic channels made our Asian market entry significantly smoother. Exceptional strategic partner.",
    image: "https://images.unsplash.com/photo-1762341104634-998bbee0ccba"
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "Understanding the EU's AI Act: Implications for Asian Markets",
    excerpt: "As the EU finalizes its groundbreaking AI regulation, businesses across Asia need to understand compliance requirements and strategic opportunities for market access.",
    category: "Technology Policy",
    date: "December 2025",
    readTime: "8 min read",
    image: "https://images.pexels.com/photos/2817465/pexels-photo-2817465.jpeg",
    link: "https://www.ft.com/content/eu-ai-act-asia-implications",
    featured: true
  },
  {
    id: 2,
    title: "The Evolution of EU-ASEAN Trade Relations in 2025",
    excerpt: "Regional Comprehensive Economic Partnership and EU trade agreements are reshaping Asian-European commerce. Here's what businesses need to know in the new year.",
    category: "International Trade",
    date: "November 2025",
    readTime: "6 min read",
    image: "https://images.unsplash.com/photo-1664785658580-07f819ce49cd",
    link: "https://www.reuters.com/markets/eu-asean-trade-evolution",
    featured: true
  },
  {
    id: 3,
    title: "China's Belt and Road Initiative: 2025 Strategic Shifts",
    excerpt: "New developments in China's Belt and Road Initiative are creating opportunities and challenges for European businesses operating in Asian markets.",
    category: "Geopolitical Strategy",
    date: "October 2025",
    readTime: "10 min read",
    image: "https://images.unsplash.com/photo-1761301643716-1cf7a6ffb6fe",
    link: "https://www.scmp.com/news/china-belt-road-2025",
    featured: false
  },
  {
    id: 4,
    title: "ESG Reporting: New 2025 Standards for Europe and Asia",
    excerpt: "Updated ESG disclosure requirements in EU and accelerated adoption in Asia are creating new compliance challenges and opportunities for multinational companies.",
    category: "Regulatory Affairs",
    date: "September 2025",
    readTime: "7 min read",
    image: "https://images.unsplash.com/photo-1529400971008-f566de0e6dfc",
    link: "https://www.politico.eu/article/esg-standards-alignment",
    featured: false
  },
  {
    id: 5,
    title: "UK-Singapore Digital Economy Agreement: 2025 Implementation",
    excerpt: "The enhanced digital economy agreement between UK and Singapore enters full implementation, opening new pathways for tech companies and financial services firms.",
    category: "Digital Trade",
    date: "July 2025",
    readTime: "6 min read",
    image: "https://images.pexels.com/photos/2817465/pexels-photo-2817465.jpeg",
    link: "https://www.theguardian.com/uk-singapore-digital-agreement",
    featured: false
  },
  {
    id: 6,
    title: "Navigating India's Foreign Investment Regulations in 2025",
    excerpt: "India's evolving FDI policies present both opportunities and compliance challenges for European investors seeking market entry this year.",
    category: "Investment Policy",
    date: "May 2025",
    readTime: "9 min read",
    image: "https://images.unsplash.com/photo-1664785658580-07f819ce49cd",
    link: "https://www.ft.com/content/india-fdi-regulations-2025",
    featured: false
  },
  {
    id: 7,
    title: "Japan's Economic Security Strategy: 2025 Updates for Foreign Firms",
    excerpt: "Japan's revised economic security framework requires foreign companies to reassess supply chains and technology partnerships heading into 2025.",
    category: "Economic Security",
    date: "March 2025",
    readTime: "8 min read",
    image: "https://images.unsplash.com/photo-1761301643716-1cf7a6ffb6fe",
    link: "https://asia.nikkei.com/japan-economic-security-2025",
    featured: false
  },
  {
    id: 8,
    title: "ASEAN Green Finance Frameworks: What's New in 2025",
    excerpt: "Southeast Asian nations launch coordinated green finance initiatives, creating new investment opportunities aligned with sustainable development goals.",
    category: "Sustainable Finance",
    date: "January 2025",
    readTime: "5 min read",
    image: "https://images.unsplash.com/photo-1529400971008-f566de0e6dfc",
    link: "https://thediplomat.com/asean-green-finance-2025",
    featured: false
  }
];

export const credentials = [
  {
    type: "Education",
    items: [
      "Ph.D. in International Relations, London School of Economics",
      "M.A. in European Policy Studies, Sciences Po Paris",
      "B.A. in Political Science & Asian Studies, University of Oxford"
    ]
  },
  {
    type: "Professional Affiliations",
    items: [
      "Fellow, European Policy Centre",
      "Member, Asia-Europe Foundation",
      "Board Member, EU-ASEAN Business Council",
      "Advisory Council, Brussels Institute for International Relations"
    ]
  },
  {
    type: "Certifications",
    items: [
      "Registered Lobbyist, EU Transparency Register",
      "Accredited Policy Advisor, European Commission",
      "Certified Government Relations Professional (International)"
    ]
  }
];

export const expertise = [
  "European Union Regulations",
  "UK Post-Brexit Policy",
  "China Market Access & Regulations",
  "ASEAN Trade & Investment Policy",
  "Digital Markets & Technology Policy",
  "Healthcare & Pharmaceutical Regulations",
  "Financial Services Compliance",
  "Environmental & Climate Policy",
  "Cross-border EU-Asia Transactions",
  "Public Affairs Strategy"
];
